
    import I18n from 'i18nObj';
    
      import 'translations/assignments.no_assignments_list_item';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('assignments.no_assignments_list_item');
  